import { inspectFormControls } from './form-inspector-shared';
import { isEmptyValue } from '@/hosting/keap-hosting-util';

const VERSION_REGEX = /1|2|3\.0\.\d+/;

export function formInspector1_0_x() {
    return {
        /**
         * Field inspector for version 1.0.22.
         *
         * Changes for version 1.0.22:
         * - form-fields are wrapped in a [class='field-container'] which also contains metadata attributes:
         * - data-required, data-name, data-type, data-label
         *
         * @param {HTMLFormElement} form
         * @param {KeapFormState} formState
         * @see inspectForm
         */
        inspectForm(form, formState) {
            const fields = form.getElementsByClassName('field-container');

            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];
                let requiredProp = field.getAttribute('data-required');
                const fieldInfo = {
                    isRequired: !isEmptyValue(requiredProp) && requiredProp !== 'false',
                    fieldName: field.getAttribute('data-name'),
                    fieldType: field.getAttribute('data-type') ?? 'text',
                    fieldLabel: field.getAttribute('data-label'),
                    defaultValue: field.getAttribute('data-value'),
                };

                inspectFormControls(field, fieldInfo, formState);
            }
        },

        /**
         * Whether this form version applies
         *
         * @param {string} version
         * @return {boolean}
         */
        applies(version) {
            return VERSION_REGEX.test(version);
        },
    };

}

